/** Chat timestamps are absolute instants on the wire; present them in the viewer's local zone. */
export function parseChatDate(value?: string): Date | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  // Older cached values may omit a zone. Treat them as UTC consistently on every client.
  const zoneLessDateTime = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/;
  const normalized = zoneLessDateTime.test(trimmed) ? `${trimmed.replace(" ", "T")}Z` : trimmed;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatChatTime(value?: string) {
  const date = parseChatDate(value);
  return date ? new Intl.DateTimeFormat(undefined, { hour: "numeric", minute: "2-digit" }).format(date) : "";
}

export function formatChatDateTime(value?: string) {
  const date = parseChatDate(value);
  return date ? new Intl.DateTimeFormat(undefined, { dateStyle: "medium", timeStyle: "short" }).format(date) : "";
}

/** Day grouping is based on each viewer's local calendar day, not the server's UTC day. */
export function messageDayKey(value?: string) {
  const date = parseChatDate(value);
  if (!date) return "unknown";
  const year = date.getFullYear().toString().padStart(4, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function messageDayLabel(value?: string, now = new Date()) {
  const date = parseChatDate(value);
  if (!date) return "";
  const dayNumber = (localDate: Date) => Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate()) / 86_400_000;
  const daysAgo = dayNumber(now) - dayNumber(date);
  if (daysAgo === 0) return "Today";
  if (daysAgo === 1) return "Yesterday";
  return date.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: date.getFullYear() === now.getFullYear() ? undefined : "numeric",
  });
}
